export default __webpack_public_path__ + "9f48c0fd25dc7b405b30d18dd332aee5.png";